import json from "../Data.js";
import Sc from "./Sc.js";
import Splide from "../vendor/@splidejs/splide/dist/js/splide.esm.js";
import gsap from '../vendor/gsap/gsap-core.js'
import CSSPlugin from "../vendor/gsap/CSSPlugin.js";
import MotionPathPlugin from "../vendor/gsap/MotionPathPlugin.js";
gsap.registerPlugin(CSSPlugin);
gsap.registerPlugin(MotionPathPlugin);

const createData = () => {

	let data = '';

	json.data.forEach(item => {

		let layers = '';
		if (item.question_layers) {
			item.question_layers.reverse();
			item.question_layers.forEach( layer => {
				let layer_class = `splide__layer`;
				if ( item.id==3 || item.id==16 ) layer_class += ' splide__layer-md--left-20';
				if ( item.id==0 ) layer_class += ' splide__layer-sm--left--15 splide__layer-md--left-0';
				layers += `<div class="${layer_class}"><picture>
							<source srcset="assets/img/questions/${item.id}/${layer}@2x.webp" type="image/webp">
							<img src="assets/img/questions/${item.id}/${layer}@2x.png" alt="${item.question}" loading="lazy">
						</picture></div>`;

			});
		}

		let wrapper_class = 'wrapper wrapper--425';
		if (item.id==16) wrapper_class = 'wrapper wrapper--530';

		data += `<li class="splide__slide flex flex-direction-sm--column flex-direction-md--row" data-satype="${item.satype||'parallax'}">

				<audio src="assets/files/mp3/${item.mp3}.mp3" class="audio" preload="none"></audio>

				<div class="splide__img">
					<picture>
						<source srcset="assets/img/questions/${item.id}/${item.question_img}@2x.webp" type="image/webp">
						<img src="assets/img/questions/${item.id}/${item.question_img}@2x.jpg" alt="${item.question}" loading="lazy">
					</picture>
					<div class="splide__layers">${layers}</div>
					<div class="splide__overlay splide__overlay--1"></div>
					<div class="splide__overlay splide__overlay--2"></div>
					<div class="splide__overlay splide__overlay--3"></div>
				</div>

				<div class="splide__body flex">

					<div class="container">

						<div class="${wrapper_class}">

							<div class="splide__header">

								<h2>${item.question}</h2>

							</div>

							<div class="row mt-sm--40">

								<div class="form__item form__item--radio">

									<label class="flex align-items-sm--center">
										<input type="radio" name="questions_1" class="js-modal" data-modal_id="${item.id}" data-modal_type="a">
										<span class="checkmark flex justify-content-sm--center align-items-sm--center">
											<span class="option">A</span>
											<span class="mark"></span>
										</span>
										<span class="text">${item.answer_a}</span>
									</label>

								</div>

								<div class="form__item form__item--radio">

									<label>
										<input type="radio" name="questions_1" class="js-modal" data-modal_id="${item.id}" data-modal_type="b">
										<span class="checkmark flex justify-content-sm--center align-items-sm--center">
											<span class="option">B</span>
											<span class="mark"></span>
										</span>
										<span class="text">${item.answer_b}</span>
									</label>

								</div>

							</div>

						</div>

					</div>

				</div>

			</li>`
	});

	return data;

}
export let homeParallax;
export let sliderQuestion;
export let nextSliderAudio = new Audio(`assets/files/mp3/${json.data[0].mp3}.mp3`);

export const splideInit = () => {

	if (homeParallax)
		homeParallax.inactive();

	const dataContainer = document.querySelector('.splide__list');
	if (!dataContainer) return;

	dataContainer.innerHTML = createData();

	sliderQuestion = document.querySelector('.splide');

	const configQuestion = {
		perMove: 1,
		arrows: false,
		pagination: false,
		drag: false,
		keyboard: false,
		type: 'slide',
		speed: 0,
	};

	sliderQuestion = new Splide(sliderQuestion, configQuestion);

	// const bar = sliderQuestion.root.querySelector('.my-slider-progress-bar');
	let counters = document.querySelectorAll('.counter');

	let audioPlay, audio, audioTimeline = gsap.timeline({ repeat: -1, paused: true });
	audioPlay = document.querySelectorAll('.audioPlay');
	audioPlay.forEach(item => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			if (audio.paused) audio.play();
			else audio.pause();
		})
	});
	audioTimeline.from('.line', {
		duration: 1,
		opacity: 0,
		stagger: .5,
	});


	sliderQuestion.on('mounted', function() {

		gsap.set(".step__mobile", {
			motionPath: {
			  path: "#path__mobile",
			  align: "#path__mobile",
			  autoRotate: true,
			  alignOrigin: [0.5, 0.5],
			  start: 0,
			  end: 0
			}
		});

		gsap.set(".step__desktop", {
			motionPath: {
			  path: "#path__desktop",
			  align: "#path__desktop",
			  autoRotate: true,
			  alignOrigin: [0.5, 0.5],
			  start: 0,
			  end: 0
			}
		});

	});

	sliderQuestion.on('mounted move', function() {

		counters.forEach(item => {
			item.innerHTML = `${sliderQuestion.index + 1} / ${sliderQuestion.length}`;
		});

	});

	sliderQuestion.on('move', function(index) {

		audio.pause();

		let total, one, start, end, rectLine;

		total = sliderQuestion.Components.Controller.getEnd();
		one = 1 / total;
		start = one * (index - 1)
		end = one * index
		rectLine = (index / total) * 100;

		gsap.to(".step__mobile", {
			duration: 1,
			ease: "power1.inOut",
			immediateRender: true,
			motionPath: {
			  path: "#path__mobile",
			  align: "#path__mobile",
			  autoRotate: true,
			  alignOrigin: [0.5, 0.5],
			  start: start,
			  end: end
			}
		});

		gsap.to(".rect__mobile", {
			duration: 1,
			ease: "power1.inOut",
			attr: {
				width: `${rectLine}%`
			}
		});

		gsap.to(".step__desktop", {
			duration: 1,
			ease: "power1.inOut",
			immediateRender: true,
			motionPath: {
			  path: "#path__desktop",
			  align: "#path__desktop",
			  autoRotate: true,
			  alignOrigin: [0.5, 0.5],
			  start: start,
			  end: end
			}
		});

		gsap.to(".rect__desktop", {
			duration: 1,
			ease: "power1.inOut",
			attr: {
				width: `${rectLine}%`
			}
		});

	});

	sliderQuestion.on('active', function(sl) {

		window.scrollTo(0, 0);

		dataContainer.style.height = "";
		dataContainer.style.height = `${sl.slide.clientHeight}px`;

		sl.slide.querySelector('.splide__body').classList.add('splide__body--show');

		if (!sl.spanim)
			sl.spanim = new SplideAnim(sl.slide);

		audio = nextSliderAudio;
		audio.onplay = () => {
			audioTimeline.play();
			gsap.set('.line', {opacity: 1});
		};
		audio.onpause = () => {
			audioTimeline.pause();
			gsap.set('.line', {opacity: 0});
		};

		if (audio.readyState>2) audio.play();
		else audio.oncanplay = () => {audio.play();};


		const next_sl = sliderQuestion.Components.Slides.getAt(sliderQuestion.index+1);
		if (next_sl) {
			const next_audio_src = next_sl.slide.querySelector('audio').src;
			nextSliderAudio = new Audio(next_audio_src);;
		}

		if (sl.index>0) {
			let label = `${sl.index} Pokracovat dal`;
			if (sl.index<10) label = `0${sl.index} Pokracovat dal`;
			if (typeof(ga)==='function') ga('send','event','Tlacitko','Kliknuti',label, 1);
		}
			

	});
	sliderQuestion.on('inactive', function(sl) {


		if (sl.spanim)
			sl.spanim.inactive()

		audio.pause();

	});

	sliderQuestion.mount();

	Sc.updates = type => {
		if (type!=='resize') return;
		const active_sl = sliderQuestion.Components.Slides.getAt(sliderQuestion.index);
		dataContainer.style.height = "";
		dataContainer.style.height = `${active_sl.slide.clientHeight}px`;
	};

}

class SplideAnim {
	constructor(el){
		this.type = el.dataset.satype;
		const TYPES = {
			'parallax': Parallax,
			'none': ParallaxBg,
			'change': Change,
			'shift': Shift,
			'tank': Tank,
			'waving': Waving,
		};

		this.active=()=>{};
		this.inactive=()=>{};
		if (!TYPES[this.type]) return;

		this.anim = new TYPES[this.type](el);
		this.active = ()=>{this.anim.active();};
		this.inactive=()=>{this.anim.inactive();};
		this.doit();
	}
	async doit(){
		await Mask.delay();
		this.active();
	}
}

class LayersAnim {
	constructor(el){
		this.el = el;
		this.bg = this.el.querySelector('img');
		this.layers = this.el.querySelectorAll('.splide__layer');
	}
	active(){}
	inactive(){}
}

class ParallaxBg extends LayersAnim {
	constructor(el){
		super(el);
		this.showFn = () => {};
		this.parallaxMoveFn = e => {

			let bg_movement = -20;
			gsap.to(this.bg, {
				duration: 1,
				x: (e.pageX - window.innerWidth / 2) / window.innerWidth * bg_movement,
				y: (e.pageY - window.innerHeight / 2) / window.innerHeight * bg_movement

			});

		}
	}
	active(){
		if (Sc.width<768) {
			this.showFn();
			return ;
		}
		this.el.addEventListener('mousemove', this.parallaxMoveFn, false);
	}
	inactive(){
		if (Sc.width<768) return;
		this.el.removeEventListener('mousemove', this.parallaxMoveFn);
	}
}
class Parallax extends ParallaxBg {
	constructor(el){
		super(el);

		if (Sc.width<768) {
			let index = 2;
			this.layers.forEach(layer => {
				let movement = index++*10

				gsap.to(layer, {
					duration: 0,
					y: (1000 - window.innerHeight / 2) / window.innerHeight * movement
				});
			});
		}
		this.showFn = () => {
			this.layers.forEach(layer => {gsap.to(layer, {duration: 3,y: 0});});
		};
		this.parallaxMoveFn = e => {

			let bg_movement = -10;
			gsap.to(this.bg, {
				duration: 1,
				x: (e.pageX - window.innerWidth / 2) / window.innerWidth * bg_movement,
				y: (e.pageY - window.innerHeight / 2) / window.innerHeight * bg_movement
			});

			let index = 2;
			this.layers.forEach(layer => {
				let movement = index++*-10
				gsap.to(layer, {
					duration: 1,
					x: (e.pageX - window.innerWidth / 2) / window.innerWidth * movement,
					y: (e.pageY - window.innerHeight / 2) / window.innerHeight * movement
				});
			});
		};
	}
}

class Change extends LayersAnim {
	constructor(el){
		super(el);

		this.timer = () => {};
		this.active_mask = -1;
		this.masks = [];
		this.createMasks();
	}
	async createMasks(){

		await Promise.all([...this.layers].map(async (layer) => {

			let img = layer.querySelector('img');
			img.style.opacity = 0;
			if (!img.currentSrc || img.currentSrc=='') {
				await new Promise((resolve, reject) => {
					img.onload = () => resolve(img);
					img.onerror = reject;
				});
			}
			const mask = document.createElement('div')
			mask.classList.add('layer-mask');
			mask.style.background = `transparent url(${img.currentSrc}) center center no-repeat`;
			mask.style.backgroundSize = "cover";
			layer.appendChild(mask);
		}));

		this.masks = this.el.querySelectorAll('.layer-mask');

		this.active();

	}
	active(){

		if (this.masks.length===0 || this.active_mask!==-1) return;

		this.active_mask++;

		this.masks[this.active_mask].classList.add('layer-mask--show');
		this.timer = setInterval(() => {
			this.masks[this.active_mask].classList.add('layer-mask--hide');

			if (this.masks.length-1===this.active_mask) this.active_mask=-1;
			this.masks[++this.active_mask].classList.remove(`layer-mask--show`, `layer-mask--hide`);
			setTimeout(() => {
				this.masks[this.active_mask].classList.add('layer-mask--show');
			}, 10);

		}, 3000);
	}
	inactive(){
		clearTimeout(this.timer);
	}
}

class Shift extends LayersAnim {
	constructor(el){
		super(el);
		this.inactive();
	}
	active(){
		gsap.to(this.layers[1], {duration: 10,x: 0,});
		gsap.to(this.layers[2], {duration: 10,x: 0,});
	}
	inactive(){
		gsap.to(this.layers[1], {duration: 0,x: window.innerWidth / 3,});
		gsap.to(this.layers[2], {duration: 0,x: window.innerWidth / -3,});
	}
}

class Tank extends LayersAnim {
	constructor(el){
		super(el);
		this.inactive();
	}
	active(){
		gsap.to(this.layers[0], {duration: 10,x: 0,});
	}
	inactive(){
		gsap.to(this.layers[0], {duration: 0,x: window.innerWidth / 1.5,});
	}
}


class Waving extends LayersAnim {
	constructor(el){
		super(el);
		this.tls = [];
		this.lposition = [50, 50, 50, 60, 80, 32];
		let index = 0;
		this.layers.forEach(layer => {
			const x = 100 - (index*10);
			let rotate = 3 - (index*2);
			if (index===4 && Sc.width<530) layer.querySelector('img').style.objectPosition = "100% 50%";
			gsap.to(layer, {duration: 0, rotation:-rotate, x:-x,transformOrigin:`${this.lposition[index]}% bottom`});
			index++;
		});
	}
	active(){
		let index = 0;
		this.layers.forEach(layer => {
			const x = 100 - (index*10);
			let dur = 7-index;
			let rotate = 3 - (index*2);
			if (index>2) rotate = 20 - (index*2);
			this.tls[index] = gsap.timeline({repeat: -1});
			this.tls[index].fromTo(layer, {rotation:-rotate, x:-x}, {duration: dur, rotation:rotate, x:x, transformOrigin:`${this.lposition[index]}% bottom`});
			this.tls[index].fromTo(layer, {rotation:rotate, x:x}, {duration: dur, rotation:-rotate, x:-x, transformOrigin:`${this.lposition[index]}% bottom`});
			index++;
		});
	}
	inactive(){
		this.tls.forEach( tl => {tl.kill();});
	}
}


export class Mask {
	constructor(){}
	static async delay(delay = 750){await new Promise(resolve => setTimeout(resolve, delay));}
	static get mask(){return document.getElementById('cloudMask');}

	static async show(mask = Mask.mask, cl='cloud-mask') {
		if (!mask) return;
		if (mask.classList.contains(`${cl}--show`)) {
			mask.classList.remove(`${cl}--show`, `${cl}--hide`);
			await Mask.delay(50);
		}
		mask.classList.add(`${cl}--show`);
		await Mask.delay();
	}
	static async hide(mask = Mask.mask, cl='cloud-mask') {
		if (!mask) return;
		await Mask.delay(200);
		mask.classList.add(`${cl}--hide`);
		await Mask.delay();
		mask.classList.remove(`${cl}--show`, `${cl}--hide`);
	}

	static async showOver() {
		Mask.mask.style.zIndex=99999999999;
		await Mask.show();
	}
	static async hideOver() {
		await Mask.hide();
		Mask.mask.style.zIndex='';
	}
}

class ParallaxHome {
	constructor(el){
		this.el = el;
		this.layers = [...this.el.children];
		this.parallaxMoveFn = e => {
			let index = 1;
			let movement = index*-10

			// gsap.to(this.el, {
			// 	duration: 1,
			// 	x: (e.pageX - window.innerWidth / 2) / window.innerWidth * movement,
			// 	y: (e.pageY - window.innerHeight / 2) / window.innerHeight * movement + 30
			// });

			this.layers.forEach(layer => {
				movement = ++index*-10
				gsap.to(layer, {
					duration: 1,
					x: (e.pageX - window.innerWidth / 2) / window.innerWidth * movement,
					y: (e.pageY - window.innerHeight / 2) / window.innerHeight * movement + 30
				});
			});
		};
		if (Sc.width<768) {
			let index = 2;
			this.layers.forEach(layer => {
				let movement = index++*10
				gsap.to(layer, {
					duration: 0,
					y: (1000 - window.innerHeight / 2) / window.innerHeight * movement
				});
			});
			this.layers.forEach(layer => {gsap.to(layer, {duration: 3,y: 0});});
			return;
		}
		document.body.addEventListener('mousemove', this.parallaxMoveFn, false);
	}
	inactive(){
		if (Sc.width<768) return;
		document.body.removeEventListener('mousemove', this.parallaxMoveFn);
	}
}


Sc.onloads = () => {
	if (document.querySelector('.home-img'))
		homeParallax = new ParallaxHome(document.querySelector('.home-img'));
}
